import { cn } from "@/lib/utils";
import { ATTACH_KINDS, BUTTON_GROUPS, BUTTON_NAME, BUTTON_SHORT, KIND_ORDER } from "@/rc/attachments";

const TONE = {
  pos: { text: "text-primary", on: "border-primary bg-primary text-primary-foreground" },
  neg: { text: "text-[hsl(var(--rc-hot))]", on: "border-[hsl(var(--rc-hot))] bg-[hsl(var(--rc-hot))] text-white" },
};

export const ButtonPicker = ({ testId, label, value, tone, conflicts, onPick }) => (
  <div className="flex flex-wrap items-center gap-x-3 gap-y-2" role="radiogroup" aria-label={`${label} button`}>
    <span className={cn("w-24 shrink-0 text-sm font-bold", TONE[tone].text)}>{label}</span>
    {BUTTON_GROUPS.map((g) => (
      <div key={g.name} className="flex gap-1" title={g.name}>
        {g.buttons.map((b) => {
          const on = value === b;
          return (
            <button
              key={b}
              type="button"
              role="radio"
              aria-checked={on}
              aria-label={BUTTON_NAME[b]}
              onClick={() => onPick(b)}
              data-testid={`${testId}-${b}`}
              className={cn(
                "h-8 min-w-8 rounded-lg border px-2 font-display text-xs font-bold transition-[background-color,color,transform,border-color] hover:-translate-y-0.5",
                on ? (conflicts.has(b) ? "border-destructive bg-destructive text-destructive-foreground" : TONE[tone].on) : "bg-background hover:border-primary/50"
              )}
            >
              {BUTTON_SHORT[b]}
            </button>
          );
        })}
      </div>
    ))}
  </div>
);

export const Segmented = ({ options, value, onChange, testId, label }) => (
  <div className="grid gap-2 sm:grid-cols-2" role="radiogroup" aria-label={label}>
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        role="radio"
        aria-checked={value === o.value}
        onClick={() => onChange(o.value)}
        data-testid={`${testId}-${o.value}`}
        className={cn(
          "rounded-xl border px-3 py-2 text-left text-sm transition-[background-color,border-color]",
          value === o.value ? "border-primary bg-secondary text-secondary-foreground ring-1 ring-primary/30" : "bg-background hover:border-primary/50"
        )}
      >
        <span className="font-semibold">{o.label}</span>
        {o.sub && <span className="mt-0.5 block text-xs opacity-75">{o.sub}</span>}
      </button>
    ))}
  </div>
);

export const KindPicker = ({ value, onChange, testId }) => (
  <div className="flex flex-wrap gap-1.5" role="radiogroup" aria-label="What is it?">
    {KIND_ORDER.map((k) => (
      <button
        key={k}
        type="button"
        role="radio"
        aria-checked={value === k}
        onClick={() => onChange(k)}
        data-testid={`${testId}-${k}`}
        className={cn(
          "rounded-full border px-3 py-1 text-xs font-semibold transition-[background-color,color,border-color]",
          value === k ? "border-primary bg-primary text-primary-foreground" : "bg-background hover:border-primary/50"
        )}
      >
        {ATTACH_KINDS[k].name}
      </button>
    ))}
  </div>
);
